module.exports = __webpack_public_path__ + "static/scale-model-of-woodbridge-park-in-roseville-california-dd4cc22845319cba40bc66da9f75a34d.png";